import { render, staticRenderFns } from "./patrons.vue?vue&type=template&id=78e6387a&"
import script from "./patrons.vue?vue&type=script&lang=js&"
export * from "./patrons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports